import { create } from "zustand";
import type { GridPreset } from "../types";

export type GuardiaEmptyReason = "none" | "no-cameras" | "all-offline";

interface GuardiaData {
  running: boolean;
  intervalSec: number;
  gridSize: GridPreset;
  cycleIndex: number; // 1-based mientras corre; 0 cuando no corre
  totalCycles: number;
  remainingSec: number;
  paused: boolean;
  verifying: boolean;
  emptyReason: GuardiaEmptyReason;
}

interface GuardiaState extends GuardiaData {
  patch: (p: Partial<GuardiaData>) => void;
  reset: () => void;
}

const INITIAL: GuardiaData = {
  running: false,
  intervalSec: 30,
  gridSize: 16,
  cycleIndex: 0,
  totalCycles: 0,
  remainingSec: 0,
  paused: false,
  verifying: false,
  emptyReason: "none",
};

// Store en memoria (sin persist): un F5 NO debe reanudar la rotacion con un
// snapshot de grilla viejo. Solo lo consume GuardiaBadge, asi el re-render por
// segundo (cuenta regresiva) queda confinado a ese componente chico.
export const useGuardiaStore = create<GuardiaState>((set) => ({
  ...INITIAL,
  patch: (p) => set(p),
  reset: () => set(INITIAL),
}));
